import(/* webpackMode: "eager", webpackExports: ["PickleballAppPage"] */ "/home/runner/work/whoplays-web/whoplays-web/src/components/pickleball-app-page.tsx");
